"use client";

import type { AuthEntryPoint } from "@/lib/analytics/types";
import type { SignedIn } from "@/lib/auth/sign-in/result";
import { CodeEntryForm } from "../code-entry-form";
import { confirmPendingSignIn } from "../sign-in-actions";
import { useAuthCompletion } from "./use-auth-completion";

export function ConfirmEmailStep(props: {
  entryPoint: AuthEntryPoint;
  onSignedIn: (result: SignedIn) => void | Promise<void>;
  onStartOver: () => void;
}) {
  const completion = useAuthCompletion({
    entryPoint: props.entryPoint,
    surface: "email_verification",
    method: "email_verification",
    onSignedIn: props.onSignedIn,
  });
  return (
    <CodeEntryForm
      isVerifying={completion.isBusy}
      error={completion.error}
      submitLabel="Confirm and continue"
      busyLabel="Confirming…"
      onVerify={(code) => completion.run(() => confirmPendingSignIn({ code }))}
      onChangeEmail={props.onStartOver}
      changeEmailLabel="Start over"
      onEdit={completion.clearError}
    />
  );
}
